import { Brand } from '@awaze/design-system.components.awaze-theme-provider'

export const typeCheckBrand = (
  givenBrandString: string,
): givenBrandString is Brand => {
  const brands: Array<Brand> = [
    'agnostic',
    'awaze',
    'cottages.com',
    'hoseasons',
    'novasol',
    'fincallorca',
    'dansommer',
  ]
  const isValidBrand = brands.includes(givenBrandString as Brand)

  return isValidBrand
}
